import { format } from 'date-fns';
import type { EntryDirection } from '../../../../services/communications';

export function formatEntryTime(occurredAt: string): string {
    try {
        return format(new Date(occurredAt), 'h:mm a');
    } catch {
        return '';
    }
}

export const DIRECTION_LABEL: Record<EntryDirection, string> = {
    incoming: 'Incoming',
    outgoing: 'Outgoing'
};

// yyyy-MM-ddTHH:mm - the value shape an <input type="datetime-local"> needs.
export function toDatetimeLocalValue(date: Date): string {
    return format(date, "yyyy-MM-dd'T'HH:mm");
}
